import button from './en-US/button';
import component from './en-US/component';
import globalHeader from './en-US/globalHeader';
import menu from './en-US/menu';
import message from './en-US/message';
import pages from './en-US/pages';
import pwa from './en-US/pwa';
import serverMessage from './en-US/serverMessage';
import settingDrawer from './en-US/settingDrawer';
import settings from './en-US/settings';

export default {
  ...pages,
  ...globalHeader,
  ...menu,
  ...settingDrawer,
  ...settings,
  ...pwa,
  ...component,
  ...message,
  ...button,
  ...serverMessage,
};
